import axios from "axios";
import React, { useEffect, useState } from "react";
import styles from "./styles.css";
import Select from "react-select";
import { useParams } from "react-router-dom";
// reactstrap components
import { FormGroup, Input, Label } from "reactstrap";
import { URL_API } from "variable";
import { EditorState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useHistory } from "react-router-dom";

import { toast } from "react-toastify";
toast.configure();

function AdminEdit() {
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ font: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image"],
      ["clean"],
      [{ align: [] }],
      ["code-block"],
    ],
  };

  const formats = [
    "header",
    "font",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "align",
    "code-block",
  ];
  const con = {
    headers: {
      ContentType: 'application/json',
      Authorization: "Bearer " + localStorage.getItem("njrujBf847hAfkxncmRbjfhy37AdyhbcKn84hdA8hggeras"),
    },
  };
  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );
  const history = useHistory();
  const [title, setTitle] = useState();
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [description, setDescription] = useState("");
  const [image, setImage] = useState();
  const [tags, setTags] = useState([]);
  const [tagList, setTagList] = useState([]);
  const [service, setService] = useState();
  const [serviceList, setServiceList] = useState([]);
  const [metaTitle, setMetaTitle] = useState();
  const [keyword, setKeyword] = useState();
  const [metaDescription, setMetaDescription] = useState();
  const id = useParams();

  useEffect(() => {
    getAdmin();
    getPermissions();
    let token = localStorage.getItem("token");
  }, []);

  const onTitleChange = (e) => {
    setTitle([e.target.value]);
  };

  const onEmailChange = (e) => {
    setEmail([e.target.value]);
  };

  const onPasswordChange = (e) => {
    setPassword([e.target.value]);
  };
  const onTagsChange = (tags) => {
    setTags(tags);
  };

  const getAdmin = () => {
    axios.get(URL_API + `auth/admin/get-admin/${id.id}`).then((response) => {
      if (response?.status == 200) {
        console.log("response", response?.data?.admin);
        setTitle(response?.data?.admin?.full_name);
        setEmail(response?.data?.admin?.email);
        const options = [];
        for (
          var i = 0;
          i < response?.data?.admin?.admin_permissions?.length;
          i++
        ) {
          var obj = {};
          obj["value"] = response?.data?.admin?.admin_permissions[i]?.id;
          obj["label"] = response?.data?.admin?.admin_permissions[i]?.name;
          options.push(obj);
        }

        setTags(options);
      }
    });
  };
  const getPermissions = () => {
    axios
      .get(URL_API + "auth/admin/permissions")
      .then((response) => {
        if (response.status == 200) {
          const options = [];
          obj = {};
          for (var i = 0; i < response?.data?.permissions.length; i++) {
            var obj = {};
            obj["value"] = response?.data?.permissions[i].id;
            obj["label"] = response?.data?.permissions[i].name;
            options.push(obj);
          }
          setTagList(options);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onSubmit = (event) => {
    event.preventDefault();
    let formData = new FormData();
    formData.append("full_name", title);
    formData.append("email", email);
    formData.append("password", password);
    formData.append("permissions", JSON.stringify(tags));

    axios
      .post(URL_API + `auth/admin/update-admin/${id.id}`, formData, con)
      .then((response) => {
        if (response.status == 200) {
          history.push("/admin/admins");
          toast.success("Admin Created Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
          setTitle("");
          setImage("");
          setDescription("");
          setTags("");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <div className="content">
        <form onSubmit={(e) => onSubmit(e)}>
          <div className={`container-fluid`}>
            <div className={styles.HeroiImgBlogForm}>
              <div className={styles.paddingTopBottomBlogForm}>
                <h3 className={styles.HeroiImgTextBlogForm}>Update Admin</h3>
              </div>
            </div>
            <br />
            <div className="container">
              <div className={`form ${styles.blogPostForm}`}>
                <div className="form-group">
                  <label htmlFor="post-title" className={styles.labelPostForm}>
                    Name
                  </label>
                  <Input
                    name="title"
                    type="text"
                    value={title}
                    id="post-title"
                    required="required"
                    onChange={(e) => onTitleChange(e)}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="post-title" className={styles.labelPostForm}>
                    email
                  </label>
                  <Input
                    name="email"
                    value={email}
                    type="email"
                    id="post-title"
                    required="required"
                    onChange={(e) => onEmailChange(e)}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="post-title" className={styles.labelPostForm}>
                    Password
                  </label>
                  <Input
                    name="password"
                    type="password"
                    id="post-title"
                    required="required"
                    onChange={(e) => onPasswordChange(e)}
                  />
                </div>

                <FormGroup>
                  <Label for="City">Permissions</Label>
                  <Select
                    allowSelectAll={true}
                    value={tags}
                    onChange={onTagsChange}
                    options={tagList}
                    isMulti={true}
                    required="required"
                  />
                </FormGroup>

                <Input
                  type="submit"
                  name="submit"
                  className={`btn btn-danger ${styles.blogPostFormBtn}`}
                  value="Post Now"
                />
              </div>
              <br />
              <br />
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default AdminEdit;
